import React, { useEffect, useState, useRef, useCallback } from "react";
import { api } from "../../services/api";

// import RestScreen from '../../components/RestScreen/RestScreen';
import Loading from "../../components/Loading/Loading";
import Product from "../../components/Product/Product";
import NotFound from "../../components/Product/NotFound/NotFound";

import RestScreen from "../../components/RestScreen/RestScreen";

const Home = () => {
  const [ean, setEan] = useState("");
  const [loading, setLoading] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [product, setProduct] = useState({
    name: "",
    price: "",
    priceOffer: "",
    fideliPrice: "",
    image: "",
    active: 0,
  });
  const [audio , setAudio] = useState(null);

  let timeoutRef = null
  const inputRef = useRef(null);

  const getEan = useCallback(
    async () => {
       setLoading(true);
      audio?.play();
      try {
        const { data: vtex } = await api.post(
          "product_vtex",
          { ean },
          { signal: new AbortController().signal }
        );

        if (vtex.Error) {
          resetTimeout()
          setNotFound(true);
          setLoading(false);
          setEan("");
          inputRef.current.focus();
          return;
        }

        setProduct({
          name: vtex.description,
          price: vtex.priceNormal,
          priceOffer: vtex.priceOffer,
          fideliPrice: vtex.priceFidelidade,
          image: vtex.urlImage.ImageUrl,
          active: 1,
        });
        setNotFound(false);
        setLoading(false);
        setEan("");
        resetTimeout()
      } catch (error) {
        if (error.name === "AbortError") {
        resetTimeout()
          return;
        }

        resetTimeout()
        setNotFound(true);
        setLoading(false);
        setEan("");
        inputRef.current.focus();
        resetTimeout()
      }
    },
    [ean]
  );

  const resetTimeout = () => {
    timeoutRef = setTimeout(() => {
      setProduct({
        name: "",
        price: "",
        priceOffer: "",
        fideliPrice: "",
        image: "",
        active: 0,
      });
      setNotFound(false);
      focusInput();
      clearTimeout(timeoutRef);
    }, 12000);
  };

  const focusInput = useCallback(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  useEffect(() => {
    if (loading && !ean) {
      clearTimeout(timeoutRef);
    }

    return () => {
      clearTimeout(timeoutRef);
    };
  }, [ean, loading]);

  useEffect(() => {
    focusInput();
    try {
      setAudio(new Audio('https://api.santolabs.com.br/api/dasboard/clube-meire/audio'))
    } catch (error) {
      console.log(error)
    }
  }, []);

  return (
    <div className="container_app">
      <input
        ref={inputRef}
        autoComplete="off"
        id="inputEan"
        type="text"
        inputMode="numeric"
        value={ean}
        name="ean"
        onChange={(e) => {
          if (!loading) {
            setEan(e.target.value);
          }
        }}
        onKeyDown={(e) => {
          if(e.keyCode === 13 && !loading && ean) {
            getEan()
            
          }
        }}
      />

      {loading && <Loading />}

      {!notFound && product.active === 0 && <RestScreen />} 
      
      {!notFound && product.active === 1 && <Product product={product} />}

      {notFound && <NotFound />}
    </div>
  );
};

export default Home;
